// src/utils.ts
import { useEffect, useLayoutEffect } from "react";
var isSSR = typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
var isBrowser = !isSSR;
var useIsomorphicEffect = isBrowser ? useLayoutEffect : useEffect;

export {
  isSSR,
  isBrowser,
  useIsomorphicEffect
};
